import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DsButtonIntent, DsButtonVariants, Icons, IconStyles } from '@levelaccess/design-system';
import { Observable } from 'rxjs';
import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface IDSButtonCellConfig extends ICellConfig {
  variant: DsButtonVariants;
  clickListener: Function;
  microActionIcon?: Icons;
  microActionIconStyle?: IconStyles;
  intent?: DsButtonIntent;
  isDisabled$?: Observable<boolean>;
  ariaLabel?: string;
}

@Component({
  selector: 'table-cell-ds-button',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  template: `
    @if (isMicroAction()) {
      <button
        ds-button
        #ref
        [variant]="config.variant"
        [microActionIcon]="config.microActionIcon"
        [hideMicroActionIcon]="!config.microActionIcon"
        [iconStyle]="config.microActionIconStyle"
        [intent]="config.intent"
        [disabled]="config?.isDisabled$ | async"
        (click)="config.clickListener()"
        [attr.aria-label]="config?.ariaLabel"
      >
        {{ config.text }}
      </button>
    } @else {
      <button
        ds-button
        #ref
        [variant]="config.variant"
        [intent]="config.intent"
        [disabled]="config?.isDisabled$ | async"
        (click)="config.clickListener()"
        [attr.aria-label]="config?.ariaLabel"
      >
        {{ config.text }}
      </button>
    }
  `,
})
export class DSButtonCellComponent extends BaseCellComponent {
  private static readonly MICRO_ACTION_VARIANTS: DsButtonVariants[] = [
    DsButtonVariants.microAction,
    DsButtonVariants.microActionHorizontalLayout,
    DsButtonVariants.microActionStacked,
    DsButtonVariants.microActionWithChevronRight,
    DsButtonVariants.microActionWithChevronRightInline,
  ];

  @Input() public config: IDSButtonCellConfig;
  @ViewChild('ref', { read: ElementRef })
  public override element: ElementRef<HTMLElement>;

  public isMicroAction(): boolean {
    return DSButtonCellComponent.MICRO_ACTION_VARIANTS.includes(this.config.variant);
  }
}
